import React from 'react';

import {
  QuestionEditorProps,
  QuizEditField,
} from '@/modules/corporate/modules/questions/fields/types';
import { QuestionTypeEnum } from '@/types/schema';

import Editor from '../../../components/Editor';
import EditorOptionsList from '../../EditorOptionsList';

const SelectEditField: QuizEditField = {
  Editor: (props: QuestionEditorProps) => (
    <Editor EditorOptionsList={EditorOptionsList} {...props} />
  ),
  type: QuestionTypeEnum.SingleSelect,
};

export default SelectEditField;
